import { Globe2, MapPin, Network } from "lucide-react";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";

const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

export function GlobalPresence({ content, mapRegions, images = [] }) {
  const groupedRegions = mapRegions.reduce((groups, region, index) => {
    const groupName = region.group || "Other";
    if (!groups[groupName]) groups[groupName] = [];
    groups[groupName].push({ ...region, label: content.regions[index] || region.name || region.key });
    return groups;
  }, {});

  return (
    <>
      <section id="global" className="section global-presence-section" data-testid="global-presence-section">
        <div className="slide-split">
          <div className="section-heading">
            <p className="overline" data-testid="global-overline">{content.overline}</p>
            <h2 data-testid="global-title">{content.title}</h2>
          </div>
          <div className="deck-image-panel" data-testid="global-image-panel-1">
            {images[0]?.image ? <img src={images[0].image} alt={content.title} data-testid="global-image-1" /> : <span>{content.overline}</span>}
          </div>
        </div>

        <div className="global-signal-strip" data-testid="global-signal-strip">
        {(content.stats || []).map((stat, index) => {
          const icons = [MapPin, Network, Globe2];
          const Icon = icons[index] || Globe2;
          return (
            <span key={stat} data-testid={`global-signal-${index + 1}`}>
              <Icon size={16} aria-hidden="true" /> {stat}
            </span>
          );
        })}
        </div>

        <div className="global-map realistic" data-testid="global-map">
        <ComposableMap
          className="map-svg"
          projection="geoMercator"
          projectionConfig={{ scale: 118, center: [12, 22] }}
          data-testid="world-map-svg"
          aria-label="Premium world map with Trinity active customer regions"
        >
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo) => (
                <Geography key={geo.rsmKey} geography={geo} className="map-country" tabIndex={-1} />
              ))
            }
          </Geographies>
          {mapRegions.map((region) => (
            <Marker key={region.key} coordinates={region.coordinates} data-testid={`map-marker-${region.key}`}>
              <g className="svg-map-marker" aria-label={`Project region: ${region.name}`}>
                <circle r="7" />
                <circle r="2.2" />
              </g>
            </Marker>
          ))}
        </ComposableMap>
        </div>
      </section>

      <section className="section global-regions-section" data-testid="global-regions-section">
        <div className="section-heading wide compact-heading">
          <p className="overline" data-testid="global-regions-overline">{content.overline}</p>
          <h2 data-testid="global-regions-title">{content.stats?.[1] || content.title}</h2>
        </div>
        {images[1]?.image ? (
          <div className="deck-strip-image" data-testid="global-image-panel-2">
            <img src={images[1].image} alt={content.title} data-testid="global-image-2" />
          </div>
        ) : null}
        <div className="global-region-groups" data-testid="global-region-groups">
        {Object.entries(groupedRegions).map(([groupName, regions]) => (
          <div className="global-region-group" key={groupName} data-testid={`global-region-group-${groupName.toLowerCase().replaceAll(" ", "-").replaceAll("&", "and")}`}>
            <strong data-testid={`global-region-group-title-${groupName.toLowerCase().replaceAll(" ", "-").replaceAll("&", "and")}`}>{groupName}</strong>
            <div className="global-region-list" data-testid={`global-region-list-${groupName.toLowerCase().replaceAll(" ", "-").replaceAll("&", "and")}`}>
              {regions.map((region, index) => (
                <span key={region.key} data-testid={`global-region-chip-${groupName.toLowerCase().replaceAll(" ", "-")}-${index + 1}`}>{region.label}</span>
              ))}
            </div>
          </div>
        ))}
        </div>

        <div className="stat-grid" data-testid="global-stats">
        {content.stats.map((stat) => (
          <div className="stat-item" key={stat} data-testid={`global-stat-${stat.toLowerCase().replaceAll(" ", "-").replaceAll("+", "plus")}`}>
            {stat}
          </div>
        ))}
        </div>
      </section>
    </>
  );
}